"use client";

import { useState } from "react";
import ErrorComponent from "@/components/empty/ErrorComponent";
import { Card, CardHeader } from "@/components/headToHead/Card";
import Table from "@/components/headToHead/Table";
import LoadingBackdrop from "@/components/loadingBackdrop/LoadingBackdrop";
import useGetHeadToHeadTeamStats from "@/utils/hooks/useGetHeadToHeadTeamStats";
import { useHeadToHeadContext } from "@/utils/hooks/useHeadToHeadContext";
import { ToggleButton, ToggleSwitch } from "../../ToggleSwitch";
import useTable, { StatTab } from "./useTable";
import styles from "./defensiveStats.module.scss";

const ContentContainer = ({ tab }: { tab: StatTab }) => {
  const { gameId } = useHeadToHeadContext();
  const { data, isLoading, isError, refetch } =
    useGetHeadToHeadTeamStats(gameId);
  const { columns, tableData } = useTable(data, tab);

  if (isError && !data) {
    return (
      <div className={styles.notLoadedContainer}>
        <ErrorComponent
          ctaButtonLabel="Retry"
          ctaButtonOnClick={() => refetch()}
        />
      </div>
    );
  } else if (isLoading && !data) {
    return (
      <div className={styles.notLoadedContainer}>
        <LoadingBackdrop loading />
      </div>
    );
  }
  return <Table data={tableData} columns={columns} />;
};

const DefensiveStats = () => {
  const [tab, setTab] = useState(StatTab.Sacks);

  return (
    <Card>
      <CardHeader
        title="Team Defensive Stats"
        action={
          <ToggleSwitch>
            <ToggleButton
              label={StatTab.Sacks}
              isActive={tab === StatTab.Sacks}
              onClick={() => setTab(StatTab.Sacks)}
            />
            <ToggleButton
              label={StatTab.PassesDefensedRate}
              isActive={tab === StatTab.PassesDefensedRate}
              onClick={() => setTab(StatTab.PassesDefensedRate)}
            />
          </ToggleSwitch>
        }
      />
      <div className={styles.content}>
        <ContentContainer tab={tab} />
      </div>
    </Card>
  );
};

export default DefensiveStats;
